import React from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';

import { colors } from 'settings/theme';
import Typography from 'components/vistaprintUILibrary/Typography';

function TextLink(props) {
  const {
    text,
    href,
    containerStyle,
    textStyle,
  } = props;

  return (
    <div
      style={containerStyle}
    >
      <a
        href={href}
      >
        <Typography
          text={text}
          style={{
            fontWeight: 'bold',
            color: colors.blueMid,
            ...textStyle,
          }}
        />
      </a>
    </div>
  );
}

TextLink.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  containerStyle: StylePropType,
  textStyle: StylePropType,
};

TextLink.defaultProps = {
  containerStyle: {},
  textStyle: {},
};

export default TextLink;



// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/TextLink.js